import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-chat-smile-2-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">
                  吃瓜网
                </span>
              </div>
              <p className="text-sm leading-relaxed text-background-400">
                最新娱乐八卦吃瓜资讯平台。每天第一时间更新最新吃瓜内容，涵盖明星绯闻、娱乐圈大瓜、社会热点事件，让你随时随地吃瓜不错过任何精彩瓜料。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    版权声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
              <div className="flex gap-3 mb-4">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="抖音"
                  rel="nofollow"
                >
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="B站"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
              <p className="text-sm text-background-400">
                联系邮箱：hello@xingyanx.cn
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 吃瓜网 All Rights Reserved. 京ICP备XXXXXXXX号
            </p>
            <p className="text-xs text-background-500">
              本站内容仅供娱乐参考，不构成任何建议
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}